<div class="rd-widget widget-{{widgetConfig?.widgetId}} valuation-results-hardcore-topslice-widget">
  <table class="widget-large widgetNoTopBorder cellspacing-0 cellpadding-0"  *ngIf="widgetData" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large-two-columns-one-gap-fifty-percent">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-space">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>

    <tbody>
      <tr class="notRotaryTableContent">
        <td colspan="10" class="lightGreyTableRow"><widget-label [widget]="this" [fieldName]="'hardCoreTopSliceGrossValueBeforeCapitalCosts'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="6" class="lightGreyTableRow"><widget-value [align]="'right'" [bold]="true">{{currency}} {{(widgetData.hardCoreTopSliceGrossValueBeforeCapitalCosts || 0) | rdLocalizedNumber:0}}</widget-value></td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="10" class="darkGreyTableHeader"><widget-label [widget]="this" [fieldName]="'labelYieldProfile'" [align]="'left'" [color]="'white'"></widget-label></td>
        <td colspan="3" class="darkGreyTableHeader color-white text-align-right">%</td>
        <td colspan="3" class="darkGreyTableHeader"><widget-label [widget]="this" [fieldName]="'labelMultiplier'" [align]="'right'" [color]="'white'"></widget-label></td>
      </tr>

      <tr>
        <td colspan="10"><widget-label [widget]="this" [fieldName]="'hardCoreTopSliceCapitalCosts'" [align]="'left'"></widget-label></td>
        <td colspan="6"><widget-value [align]="'right'">{{currency}} {{(widgetData.hardCoreTopSliceCapitalCosts || 0) | rdLocalizedNumber:0}}</widget-value></td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="10"><widget-label [widget]="this" [fieldName]="'labelGrossInitialYield'" [align]="'left'"></widget-label></td>
        <td colspan="3"><widget-value [align]="'right'">{{(widgetData.initialYield || 0) * 100 | rdLocalizedNumber:2}} %</widget-value></td>
        <td colspan="3"><widget-value [align]="'right'">{{(widgetData.initialYieldFactor || 0) | rdLocalizedNumber:2}} x</widget-value></td>
      </tr>

      <tr>
        <td colspan="10" class="lightGreyTableRow"><widget-label [widget]="this" [fieldName]="'hardCoreTopSliceGrossValueAfterCapitalCosts'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="6" class="lightGreyTableRow"><widget-value [align]="'right'" [bold]="true">{{currency}} {{(widgetData.hardCoreTopSliceGrossValueAfterCapitalCosts || 0) | rdLocalizedNumber:0}}</widget-value></td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="10" class="lightGreyTableRow"><widget-label [widget]="this" [fieldName]="'netInitialYield'" [align]="'left'"></widget-label></td>
        <td colspan="3" class="lightGreyTableRow"><widget-value [align]="'right'">{{(widgetData.netInitialYield || 0) * 100 | rdLocalizedNumber:2}} %</widget-value></td>
        <td colspan="3" class="lightGreyTableRow"><widget-value [align]="'right'">{{(widgetData.netInitialYieldFactor || 0) | rdLocalizedNumber:2}} x</widget-value></td>
      </tr>

      <tr>
        <td colspan="10"><widget-label [widget]="this" [fieldName]="'hardCoreTopSliceLessPurchasersCostsAmount'" [align]="'left'"></widget-label></td>
        <td colspan="3"><widget-value [align]="'right'">{{(widgetData.hardCoreTopSliceLessPurchasersCostsPercent || 0) * 100 | rdLocalizedNumber:1}} %</widget-value></td>
        <td colspan="3"><widget-value [align]="'right'">{{currency}} {{(widgetData.hardCoreTopSliceLessPurchasersCostsAmount || 0) | rdLocalizedNumber:0}}</widget-value></td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="10"><widget-label [widget]="this" [fieldName]="'labelGrossReversionaryYield'" [align]="'left'"></widget-label></td>
        <td colspan="3"><widget-value [align]="'right'">{{(widgetData.grossReversionaryYield || 0) * 100 | rdLocalizedNumber:2}} %</widget-value></td>
        <td colspan="3"><widget-value [align]="'right'">{{(widgetData.grossReversionaryYieldFactor || 0) | rdLocalizedNumber:2}} x</widget-value></td>
      </tr>

      <tr>
        <td colspan="10" class="lightGreyTableRow"><widget-label [widget]="this" [fieldName]="'hardCoreTopSliceNetMarketValueRounded'" [align]="'left'" [bold]="true"></widget-label></td>
        <td colspan="6" class="lightGreyTableRow"><widget-value [align]="'right'" [bold]="true">{{(widgetData.hardCoreTopSliceNetMarketValueRounded || 0) | rdLocalizedNumber:0}}</widget-value></td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="10" class="lightGreyTableRow"><widget-label [widget]="this" [fieldName]="'labelNetReversionaryYield'" [align]="'left'"></widget-label></td>
        <td colspan="3" class="lightGreyTableRow"><widget-value [align]="'right'">{{(widgetData.reversionaryYield || 0) * 100 | rdLocalizedNumber:2}} %</widget-value></td>
        <td colspan="3" class="lightGreyTableRow"><widget-value [align]="'right'">{{(widgetData.reversionaryYieldFactor || 0) | rdLocalizedNumber:2}} x</widget-value></td>
      </tr>

      <tr>
        <td colspan="10">
          <widget-label [widget]="this" [fieldName]="'labelValuePerLettableArea1'" [align]="'left'" [inline]="true"></widget-label>
          <span> {{unitOfArea}} </span>
          <widget-label [widget]="this" [fieldName]="'labelValuePerLettableArea2'" [align]="'left'" [inline]="true"></widget-label>
        </td>
        <td colspan="6"><widget-value [align]="'right'">{{currency}} {{(widgetData.valuePerLettableArea || 0) | rdLocalizedNumber:0}}</widget-value></td>
        <td colspan="1" class="space">&nbsp;</td>
        <td colspan="10"><widget-label [widget]="this" [fieldName]="'equivalentYield'" [align]="'left'"></widget-label></td>
        <td colspan="3"><widget-value [align]="'right'">{{(widgetData.equivalentYield || 0) * 100 | rdLocalizedNumber:2}} %</widget-value></td>
        <td colspan="3"><widget-value [align]="'right'">{{(widgetData.equivalentYieldFactor || 0) | rdLocalizedNumber:2}} x</widget-value></td>
      </tr>

    </tbody>
  </table>
</div>
